'use client';
import useSWR from 'swr';

import { Fragment } from 'react';
import { clsx } from 'clsx';

import { ParagraphSkeleton } from '@monoimin/atoms';
import { NotFoundIntro } from '@ms/components/NotFound/NotFoundIntro';
import { NotFoundAnalytics } from '@ms/components/NotFound/NotFoundAnalytics';
import { NotFoundArticles } from '@ms/components/NotFound/NotFoundArticles';

const fetcher = (url: string) => fetch(url).then((res) => res.json());

interface NotFoundContentProps {
  locale: string;
  className?: string;
  miniSiteSlug: string;
}

export function NotFoundContent({
  locale,
  className,
  miniSiteSlug,
}: NotFoundContentProps) {
  const url = `/api/page-404/${locale}/${miniSiteSlug}/`;
  const { data, isLoading } = useSWR(url, fetcher);
  if (isLoading) {
    return (
      <div className={clsx('flex flex-col lg:gap-[100px] gap-15', className)}>
        <div className='flex flex-col gap-5'>
          <ParagraphSkeleton columns={[12]} variant='h1' />
          <ParagraphSkeleton columns={[8, 8, 8, 7]} variant='h4' />
        </div>
        <div className='flex flex-col gap-7'>
          <ParagraphSkeleton columns={[12]} variant='h2' />
          <ParagraphSkeleton columns={[8, 8, 8, 7]} variant='h4' />
        </div>
      </div>
    );
  }
  return (
    <Fragment>
      <NotFoundAnalytics />
      <div
        className={clsx(
          'flex flex-col lg:gap-[100px] gap-15 lg:mb-[100px] mb-15',
          className
        )}
      >
        <NotFoundIntro heading={data?.title} lead={data?.lead} />
        <NotFoundArticles cards={data?.cards} />
      </div>
    </Fragment>
  );
}
